import * as React from 'react';
import { cn } from '@/lib/utils';

interface RAGThresholdVisualizerProps {
  greenThreshold: number;
  amberThreshold: number;
  className?: string;
}

export function RAGThresholdVisualizer({
  greenThreshold,
  amberThreshold,
  className,
}: RAGThresholdVisualizerProps) {
  const redWidth = amberThreshold;
  const amberWidth = greenThreshold - amberThreshold;
  const greenWidth = 100 - greenThreshold;

  return (
    <div className={cn('w-full', className)}>
      <div className="flex h-8 w-full overflow-hidden rounded-md border">
        <div
          className="flex items-center justify-center bg-red-500 text-white text-xs font-medium"
          style={{ width: `${redWidth}%` }}
        >
          {redWidth > 15 && 'RED'}
        </div>
        <div
          className="flex items-center justify-center bg-amber-500 text-white text-xs font-medium"
          style={{ width: `${amberWidth}%` }}
        >
          {amberWidth > 15 && 'AMBER'}
        </div>
        <div
          className="flex items-center justify-center bg-green-500 text-white text-xs font-medium"
          style={{ width: `${greenWidth}%` }}
        >
          {greenWidth > 15 && 'GREEN'}
        </div>
      </div>
      <div className="mt-1 flex justify-between text-xs text-muted-foreground">
        <span>0%</span>
        <span style={{ marginLeft: `${amberThreshold - 3}%` }}>{amberThreshold}%</span>
        <span style={{ marginLeft: `${greenThreshold - amberThreshold - 10}%` }}>{greenThreshold}%</span>
        <span>100%</span>
      </div>
    </div>
  );
}
